export default __webpack_public_path__ + "static/media/HDTX_Form Daftar Buyback_Scrip 2025.608c83e9.pdf";